import { ChevronDown, ChevronUp } from 'lucide-react';
import AssetSection from './AssetSection';

export default function AdSection({
  ad,
  types,
  updates,
  previews,
  warnings,
  expanded,
  onToggle,
  onUpload,
  onRemove,
  editMode,
  mediaKey = 'image_urls',
  assetKey = 'images',
}) {
  const adId = ad.id;
  const removedList = updates[adId]?.assets?.[assetKey]?.to_remove
    ?.map(r => r.asset_group_resource_name) || [];

  const mediaList = ad[mediaKey] || [];

  return (
    <div className="space-y-2">
      <div
        className="flex items-center justify-between cursor-pointer hover:bg-gray-50 -mx-2 px-2 py-1 rounded"
        onClick={() => onToggle(adId)}
      >
        <div className="text-xs font-medium text-gray-500">
          {ad.name?.trim() || 'Anuncio sin nombre'}
        </div>
        <div className="text-gray-500">
          {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </div>
      {expanded && (
        <div className="space-y-4 border border-gray-100 rounded-xl p-4 bg-white">
          {types.map(({ key, label }) => (
            <AssetSection
              key={key}
              adId={adId}
              type={key}
              label={label}
              images={assetKey === 'images' ? mediaList.filter(m => m.type === key) : []}
              videos={assetKey === 'videos' ? mediaList.filter(m => m.type === key) : []}
              previews={previews[adId]?.[key] || []}
              removedList={removedList}
              warning={warnings[adId]?.[key]}
              onUpload={onUpload}
              onRemove={onRemove}
              editMode={editMode}
              mediaKey={assetKey}
              acceptedFiles={assetKey === 'images' ? 'image/*' : 'video/*'}
            />
          ))}
        </div>
      )}
    </div>
  );
}
